function isEmpty(object) {
  return Boolean(object) && Boolean(Object.keys(object).length);
}
export {
  isEmpty
};
//# sourceMappingURL=object-utils.js.map
